import { render } from "./ReferenceInfoTableHeader.vue?vue&type=template&id=fa74037e&scoped=true"
import script from "./ReferenceInfoTableHeader.vue?vue&type=script&lang=js"
export * from "./ReferenceInfoTableHeader.vue?vue&type=script&lang=js"

import "./ReferenceInfoTableHeader.vue?vue&type=style&index=0&id=fa74037e&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa74037e"]])

export default __exports__